export default "__VITE_ASSET__CLOGsaGG__"